import { render, staticRenderFns } from "./File.vue?vue&type=template&id=5f9e521a&scoped=true"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"
import style0 from "./File.vue?vue&type=style&index=0&id=5f9e521a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e521a",
  null
  
)

export default component.exports